<template>
    <div>
        <v-card flat>
            <v-card-title>
                <span class="text-h5">Zona: {{ zoneData.name }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="3" sm="3" md="3" class="pb-0">
                            <v-text-field v-model="zoneData.name" label="Nombre" outlined class="mb-3"></v-text-field>
                        </v-col>
                        <v-col cols="9" sm="9" md="9" class="pb-0">
                            <v-text-field v-model="zoneData.description" label="Descripcion" outlined class="mb-3"></v-text-field>
                        </v-col>
                    </v-row>

                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeModal">
                    Cancelar
                </v-btn>
                <v-btn :disabled="!isOk" color="blue darken-1" text @click="save">
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>

</template>
<script>
import { createInventoryZone, updateInventoryZone, deleteInventoryZone } from '@/dataApi'
export default {
    props: {
        zoneData: {
            type: Object,
            default: () => ({
                name: '',
                description: '',
                id: null,
                active: true
            })
        }
    },
    name: 'zones',

    methods: {
        closeModal(action = null, data = null) {
            this.$emit('closeModal', action, data);
        },

        viewRequest(zone) {
            this.zoneId = zone.id || null;
            this.keyView++;
            this.getView = true;
        },

        save() {
            if (this.zoneData.id) {
                this.updateZone();
            } else {
                this.createZone();
            }
        },

        async createZone() {
            delete this.zoneData.id;
            const zone = await createInventoryZone(this.zoneData);
            this.closeModal('create', zone.data);
        },

        async updateZone() {
            await updateInventoryZone(this.zoneData);
            this.closeModal('update', this.zoneData);
        },

        async deleteZone() {
            await deleteInventoryZone(this.zoneData.id);
            //this.closeModal('delete', null);
        },
    },

    computed: {
        isOk() {
            return this.zoneData.name.trim() !== '' && this.zoneData.description.trim() !== '';
        }
    }
}
</script>